export default "__VITE_ASSET__079e59f7__"